import { PathEnum } from '@/i18n/locale-config';
import { useRouter } from '@/i18n/navigation';
import { Json } from '@/types/database.types';
import { useTranslations } from 'next-intl';

export interface GetUserTicketsResponse {
    tickets: TicketAllocation[];
    benefits: TicketAllocation[];
}

interface Screening {
    id: string;
    name: string;
    start_time: string;
    end_time: string;
    location_id: string | null;
    screening_type: 'ONLINE' | 'OFFLINE';
}

interface TicketAllocation {
    ticketId: string;
    name: string;
    usage_limits: Json;
    ticketPath: string | null;
    screening?: Screening | null;
}

export default function BenefitRowItem({ name }: TicketAllocation) {
    // const formattedDate = new Date(date).toLocaleDateString();
    const t = useTranslations();
    const router = useRouter();

    return (
        <div className="flex items-center max-lg:flex-col max-lg:items-start max-lg:w-full gap-5 py-5 border-b border-white/50 lg:justify-between max-lg:w-fit text-md lg:text-h6 uppercase text-white">
            <div className="max-w-[690px] min-w-[690px] max-sm:max-w-[400px] max-sm:min-w-[400px] w-full flex-1">
                {name}
            </div>
            <button className="uppercase text-primary" onClick={() => router.push(PathEnum.Films)}>
                {t('Checkout.use')}
            </button>
            {/* <div className="max-w-[350px] min-w-[350px] w-full text-white/50">{formattedDate}</div>
            {voucher ? (
                <div className="max-w-[100px] min-w-[100px] w-full text-right max-xl:pr-4">
                    {voucher}
                </div>
            ) : (
                <ViewButton />
            )} */}
        </div>
    );
}
